import api from './api';

export const usersService = {
  getUsers: async (params = {}) => {
    const response = await api.get('/auth/users/', { params });
    return response.data;
  },

  createUser: async (userData) => {
    const response = await api.post('/auth/users/', userData);
    return response.data;
  },

  getUserById: async (id) => {
    const response = await api.get(`/auth/users/${id}/`);
    return response.data;
  },

  updateUser: async (id, userData) => {
    const response = await api.put(`/auth/users/${id}/`, userData);
    return response.data;
  },

  partialUpdateUser: async (id, userData) => {
    const response = await api.patch(`/auth/users/${id}/`, userData);
    return response.data;
  },

  deleteUser: async (id) => {
    await api.delete(`/auth/users/${id}/`);
  },

  getStates: async () => {
    const response = await api.get('/auth/states/');
    return response.data;
  },

  getDiseases: async () => {
    const response = await api.get('/auth/diseases/');
    return response.data;
  },

  getTeamHierarchy: async () => {
    const response = await api.get('/auth/team-hierarchy/');
    return response.data;
  },

  getAvailableTeamLeads: async () => {
    const response = await api.get('/auth/team-leads/available/');
    return response.data;
  },

  getAvailableAssistantManagers: async () => {
    const response = await api.get('/auth/assistant-managers/available/');
    return response.data;
  },
};